import * as React from 'react';

import { PropertySummaryHeader } from '@shared-ui/lodging-property-details';

import { usePropertyListing } from 'src/common/stores/contexts';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

export const HeaderSummary: React.FC<SharedUiWrapperProps> = ({ inputs }) => {
  const { getSummaryPlaceholderData } = usePropertyListing();

  return (
    <div data-stid="content-hotel-title">
      <PropertySummaryHeader inputs={inputs} placeholderData={getSummaryPlaceholderData?.()} />
    </div>
  );
};

export const SharedUiHeaderSummary = withSharedUiPropertyDetails<SharedUiWrapperProps>(HeaderSummary);
SharedUiHeaderSummary.displayName = 'SharedUiHeaderSummary';
